export default __webpack_public_path__ + "static/media/QSGRW_PC_Colour.adff1a0f.png";